export default __webpack_public_path__ + "static/media/1439.99a0885f.png";